import * as yup from 'yup'

const schema = yup.object().shape({
  visibilityType: yup.string().required(),
  title: yup.string().required(),
  subtitle: yup.string().max(500).required(),
  content: yup
    .string()
    .max(5000, 'Quantidade de caracteres acima do permitido!')
    .required(),
  attachments: yup.mixed().fileUpload({ sizeLimit: 25 }),
})

export default schema
